import { submitRatingApi, fetchRatingsApi, fetchTrustScoreApi } from '../../Api/Rating/ratingApi'
import { toast } from 'react-toastify'

export const SUBMIT_RATING_REQUEST = 'SUBMIT_RATING_REQUEST'
export const SUBMIT_RATING_SUCCESS = 'SUBMIT_RATING_SUCCESS'
export const SUBMIT_RATING_FAILURE = 'SUBMIT_RATING_FAILURE'

export const FETCH_RATINGS_REQUEST = 'FETCH_RATINGS_REQUEST'
export const FETCH_RATINGS_SUCCESS = 'FETCH_RATINGS_SUCCESS'
export const FETCH_RATINGS_FAILURE = 'FETCH_RATINGS_FAILURE'

export const FETCH_TRUST_SCORE_REQUEST = 'FETCH_TRUST_SCORE_REQUEST'
export const FETCH_TRUST_SCORE_SUCCESS = 'FETCH_TRUST_SCORE_SUCCESS'
export const FETCH_TRUST_SCORE_FAILURE = 'FETCH_TRUST_SCORE_FAILURE'

export const submitRatingAction = (data, onSuccess) => async (dispatch) => {
  dispatch({ type: SUBMIT_RATING_REQUEST })
  try {
    const res = await submitRatingApi(data)
    dispatch({ type: SUBMIT_RATING_SUCCESS, payload: res.data })
    toast.success(res.data?.updated ? 'Rating updated!' : 'Rating submitted!')
    onSuccess?.()
  } catch (err) {
    const msg = err?.response?.data?.error || err?.message || 'Failed to submit rating'
    dispatch({ type: SUBMIT_RATING_FAILURE, payload: msg })
    toast.error(msg)
  }
}

export const fetchRatingsAction = (params, onSuccess) => async (dispatch) => {
  dispatch({ type: FETCH_RATINGS_REQUEST })
  try {
    const res = await fetchRatingsApi(params)
    dispatch({ type: FETCH_RATINGS_SUCCESS, payload: res.data })
    onSuccess?.(res.data)
  } catch (err) {
    dispatch({ type: FETCH_RATINGS_FAILURE, payload: err?.message || 'Failed to fetch ratings' })
  }
}

export const fetchTrustScoreAction = (userId, onSuccess) => async (dispatch) => {
  dispatch({ type: FETCH_TRUST_SCORE_REQUEST })
  try {
    const res = await fetchTrustScoreApi(userId)
    dispatch({ type: FETCH_TRUST_SCORE_SUCCESS, payload: res.data })
    onSuccess?.(res.data)
  } catch (err) {
    dispatch({ type: FETCH_TRUST_SCORE_FAILURE, payload: err?.message || 'Failed to fetch trust score' })
  }
}
